import Splide from "@splidejs/splide";

export default () => {
  const advantage_splide = document.querySelector("#advantage_splide");
  advantage_splide ? new Splide("#advantage_splide", {
    type       : "slide", // Tambien puede ser loop para que se vea infinito
    perPage    : 4,
    perMove    : 1,
    gap        : "3rem",
    padding    : {
      left: '3rem',
      right: '3rem',
    },
    breakpoints: {
      '1152': {
        perPage: 3,
      },
      '1024': {
        gap: "3.5rem",
        padding: { left: "3.5rem", right: "3.5rem" },
        perPage: 3,
      },
      '768': {
        gap: "4rem",
        padding: { left: "4rem", right: "4rem" },
        perPage: 2,
      },
      '668': {
        gap: "7rem",
        padding: { left: "7rem", right: "7rem" },
        perPage: 1,
      },
      '560': {
        gap: "6rem",
        padding: { left: "6rem", right: "6rem" },
        perPage: 1,
      },
      '440': {
        gap: "5rem",
        padding: { left: "5rem", right: "5rem" },
        perPage: 1,
      },
      '400': {
        gap: "4rem",
        padding: { left: "4rem", right: "4rem" },
        perPage: 1,
      },
      '380': {
        gap: "3rem",
        padding: { left: "3rem", right: "3rem" },
        perPage: 1,
      }
    },
    rewind     : true,
    pagination : false,
    keyboard   : "focused",
  }).mount() : ""
}
